"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create_canvas = create_canvas;
Object.defineProperty(exports, "bar_chart", {
  enumerable: true,
  get: function get() {
    return _bar["default"];
  }
});
Object.defineProperty(exports, "line_chart", {
  enumerable: true,
  get: function get() {
    return _line["default"];
  }
});
Object.defineProperty(exports, "pie_chart", {
  enumerable: true,
  get: function get() {
    return _pie["default"];
  }
});
Object.defineProperty(exports, "radar_chart", {
  enumerable: true,
  get: function get() {
    return _radar["default"];
  }
});
Object.defineProperty(exports, "roadmap", {
  enumerable: true,
  get: function get() {
    return _roadmap["default"];
  }
});
Object.defineProperty(exports, "helpers", {
  enumerable: true,
  get: function get() {
    return _helpers["default"];
  }
});
Object.defineProperty(exports, "draw", {
  enumerable: true,
  get: function get() {
    return _draw["default"];
  }
});
Object.defineProperty(exports, "math", {
  enumerable: true,
  get: function get() {
    return _math["default"];
  }
});

var _bar = _interopRequireDefault(require("./charts/bar"));

var _line = _interopRequireDefault(require("./charts/line"));

var _pie = _interopRequireDefault(require("./charts/pie"));

var _radar = _interopRequireDefault(require("./charts/radar"));

var _roadmap = _interopRequireDefault(require("./visualizations/roadmap"));

var _helpers = _interopRequireDefault(require("./helpers/helpers"));

var _draw = _interopRequireDefault(require("./helpers/draw"));

var _math = _interopRequireDefault(require("./helpers/math"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// create_canvas
// -----------------------------------
function create_canvas(el_container) {
  var el_canvas = document.createElement('canvas');
  var test_canvas = document.createElement('canvas');

  function set_canvas_size(canvas, w, h, pixel_ratio) {
    canvas.width = w * pixel_ratio;
    canvas.height = h * pixel_ratio;
    canvas.style.width = w + 'px';
    canvas.style.height = h + 'px';
    canvas.pixel_ratio = pixel_ratio;
  }

  function handle_resize(ev, suppress_onwards_event) {
    var s = getComputedStyle(el_container);
    var container_w = parseInt(s.width);
    var container_h = parseInt(s.height);

    if (container_w && container_h) {
      set_canvas_size(el_canvas, container_w, container_h, _helpers["default"].get_pixel_ratio(test_canvas));

      if (!suppress_onwards_event) {
        el_canvas.dispatchEvent(new CustomEvent('BoggleChart:resize'));
      }
    }
  }

  window.addEventListener('resize', function (ev) {
    return handle_resize(ev, false);
  });
  el_canvas.addEventListener('force_resize', function (ev) {
    return handle_resize(null, true);
  });
  el_container.appendChild(el_canvas);
  setTimeout(handle_resize, 0);
  return el_canvas;
}